import React from 'react';
import PropTypes from 'prop-types';

import Funnel from '../widgets/funnel';

const { arrayOf, number, shape, string } = PropTypes;

const ContractFunnel = ({ data }) => <Funnel data={data} />;

ContractFunnel.propTypes = {
  data: arrayOf(shape({
    label: string.isRequired,
    value: number.isRequired,
  })).isRequired,
};

export default ContractFunnel;



// WEBPACK FOOTER //
// ./src/app/components/contracting-dashboard/components/charts/contractFunnel.jsx